import React from "react";

import styles from "./SystemSettings.module.scss";

export const SystemSettingsContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.systemSettingsContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const SettingsSection: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.settingsSection} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Row: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.row} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const RowSection: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.rowSection} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Divider: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.divider} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Section: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.section} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const VerticalDivider: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.verticalDivider} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
